import { z } from 'zod/v4';
import { CompanyDocumentSchema } from './company-document.js';

export const COMPANY_DOCUMENT_PRIVACY_STATUS = {
  PUBLIC: 'public',
  SHARED: 'shared',
  SHARED_TO: 'shared_to',
  SHARED_BY: 'shared_by',
  PRIVATE: 'private',
  PRIVATE_REQUESTS: 'private_requests',
} as const;

export const CompanyDocumentPrivacyStatusSchema = z.object({
  status: z.enum([
    COMPANY_DOCUMENT_PRIVACY_STATUS.PUBLIC,
    COMPANY_DOCUMENT_PRIVACY_STATUS.SHARED,
    COMPANY_DOCUMENT_PRIVACY_STATUS.SHARED_TO,
    COMPANY_DOCUMENT_PRIVACY_STATUS.SHARED_BY,
    COMPANY_DOCUMENT_PRIVACY_STATUS.PRIVATE,
    COMPANY_DOCUMENT_PRIVACY_STATUS.PRIVATE_REQUESTS,
  ]),
  /** Only on `shared` and `private_requests`: how many companies asked / were approved. */
  requests: z.number().int().optional(),
  approvedRequests: z.number().int().optional(),
});

export type CompanyDocumentPrivacyStatus = z.infer<
  typeof CompanyDocumentPrivacyStatusSchema
>;

/** One row of `company_documents_permissions` — a company that was granted, or asked for, access. */
export const CompanyDocumentPermissionSchema = z.object({
  documentId: z.string(),
  documentOwnerCompanyId: z.string().nullable(),
  sharedWithCompanyId: z.string(),
  sharedWithCompanyName: z.string().nullable(),
  requestedAt: z.coerce.date().nullable(),
  approvedAt: z.coerce.date().nullable(),
});

export type CompanyDocumentPermission = z.infer<
  typeof CompanyDocumentPermissionSchema
>;

export const GetCompanyDocumentParamsSchema = z.object({
  id: z.string().min(1),
});

export type GetCompanyDocumentParams = z.infer<
  typeof GetCompanyDocumentParamsSchema
>;

export const CompanyDocumentDetailSchema = CompanyDocumentSchema.extend({
  permissions: z.array(CompanyDocumentPermissionSchema),
  privacyStatus: CompanyDocumentPrivacyStatusSchema,
});

export type CompanyDocumentDetail = z.infer<typeof CompanyDocumentDetailSchema>;
